module.exports = __webpack_public_path__ + "static/media/choosing_lv.4218ca93.svg";